module.exports = __webpack_public_path__ + "static/media/swaraj_744.db91ed2b.png";